export const shoulderIsoExtrotPainText = {
  values: [
    { value: 'ShoulderIsoExtrotPain', text: 'Ja', score: 1 },
    { value: 'ShoulderIsoExtrotPain', text: 'Nei', score: 0 },
    {
      value: 'ShoulderIsoExtrotPain',
      text: 'Ikke aktuelt',
      score: -1,
    },
  ],
};
